export default "__VITE_ASSET__CHfs6lmG__"